
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/account-admin-tools/jst/RestoreContentPane';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <option value=\"course\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.restore_content_pane")
  },data:data},helper ? helper.call(depth0, "courses_43204aae", "Courses", options) : helperMissing.call(depth0, "t", "courses_43204aae", "Courses", options)))
    + "\n    </option>\n    ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <option value=\"user\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.restore_content_pane")
  },data:data},helper ? helper.call(depth0, "users_d1b60cb0", "Users", options) : helperMissing.call(depth0, "t", "users_d1b60cb0", "Users", options)))
    + "\n    </option>\n    ";
  return buffer;
  }

function program5(depth0,data) {
  
  
  return "\n<div id=\"courseRestore\" class=\"restoreTypeContent\">\n  <hr aria-hidden=\"true\"/>\n  <div id=\"courseSearchResults\"></div>\n</div>\n";
  }

function program7(depth0,data) {
  
  
  return "\n<div id=\"userRestore\" class=\"restoreTypeContent\">\n  <hr aria-hidden=\"true\"/>\n  <div id=\"userSearchResults\"></div>\n</div>\n";
  }

  buffer += "<label class=\"control-label\" for=\"restoreType\">\n  <h2>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.restore_content_pane")
  },data:data},helper ? helper.call(depth0, "select_a_type_to_restore_de2c0d04", "Select a type to restore", options) : helperMissing.call(depth0, "t", "select_a_type_to_restore_de2c0d04", "Select a type to restore", options)))
    + "</h2>\n</label>\n\n<div class=\"controls\">\n  <select id=\"restoreType\">\n    <option value=\"default\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("accounts.admin_tools.restore_content_pane")
  },data:data},helper ? helper.call(depth0, "accounts.admin_tools.restore_content_pane.select_default", "Select a restore type", options) : helperMissing.call(depth0, "t", "accounts.admin_tools.restore_content_pane.select_default", "Select a restore type", options)))
    + "</option>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.restore_course), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.restore_user), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </select>\n</div>\n<hr aria-hidden=\"true\"/>\n\n<div id=\"entity_search_mount_point\"></div>\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.restore_course), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.restore_user), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  